import { Navigate, useLocation } from "react-router-dom";

/** Редиректы со старых *.html URL на роуты SPA. */
export function LegacyRedirect() {
  const location = useLocation();
  const path = location.pathname.toLowerCase();
  const params = new URLSearchParams(location.search);

  if (path === "/cabinet.html") {
    const folder = params.get("folder");
    const q = folder ? `?folder=${encodeURIComponent(folder)}` : "";
    return <Navigate to={`/cabinet${q}`} replace />;
  }
  if (path === "/login.html") {
    return <Navigate to={`/login${location.search}`} replace />;
  }
  if (path === "/register.html") {
    return <Navigate to={`/login${location.search}`} replace />;
  }
  if (path === "/trash.html") {
    return <Navigate to="/trash" replace />;
  }
  if (path === "/forgot-password.html") {
    return <Navigate to="/login" replace />;
  }
  if (path === "/reset-password.html") {
    return <Navigate to="/login" replace />;
  }
  if (path === "/board-settings.html") {
    const id = params.get("id");
    if (id) return <Navigate to={`/board/${id}/settings`} replace />;
    return <Navigate to="/cabinet" replace />;
  }
  if (path === "/board.html") {
    const id = params.get("id");
    const k = params.get("k");
    if (id && k) {
      return <Navigate to={`/guest/board/${id}?k=${encodeURIComponent(k)}`} replace />;
    }
    return <Navigate to="/" replace />;
  }
  if (path === "/user-board.html") {
    const id = params.get("id");
    if (id) {
      const t = params.get("t");
      const q = t ? `?t=${encodeURIComponent(t)}` : "";
      return <Navigate to={`/board/${id}${q}`} replace />;
    }
    return <Navigate to="/cabinet" replace />;
  }

  return <Navigate to="/" replace />;
}
